import { HTTP_ERROR_BAD_REQUEST } from '@ogsnetwork/opp-api-lib';
import { useEffect, useState } from 'react';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export function useStateWithValidation(validator, defaultValue, dependencies) {
    var _a;
    const [value, setValue] = useState(defaultValue);
    const [isValid, setIsValid] = useState(false);
    const [isPristine, setIsPristine] = useState(true);
    const [errors, setErrors] = useState();
    function setValueAndValidate(value) {
        const { isValid, errors } = validator(value);
        setIsValid(isValid);
        setIsPristine(false);
        setErrors(errors);
        setValue(value);
    }
    function reset() {
        setIsValid(false);
        setIsPristine(true);
        setErrors(undefined);
        setValue(defaultValue);
    }
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    if ((_a = dependencies === null || dependencies === void 0 ? void 0 : dependencies.length) !== null && _a !== void 0 ? _a : 0 > 0) {
        useEffect(() => {
            const { isValid: valueIsValid, errors: validationErrors } = validator(value);
            setIsValid(valueIsValid);
            if (!isPristine) {
                setErrors(validationErrors);
            }
        }, dependencies);
    }
    return { value, setValue: setValueAndValidate, reset, isValid, isPristine, errors };
}
export function combineValidationErrors(...errors) {
    return errors.reduce((previousValue, error) => {
        if (typeof error !== 'undefined') {
            if (typeof previousValue === 'undefined') {
                previousValue = {
                    data: Object.assign({}, error),
                    type: HTTP_ERROR_BAD_REQUEST
                };
            }
            else {
                previousValue.data = Object.assign(Object.assign({}, previousValue.data), error);
            }
        }
        return previousValue;
    }, undefined);
}
